/**
 * 交流合作专区 活动 API
 */

import request from '@/utils/request'

export default {
  get: (data) => {
    return request.get(`/api/frLegalPlatform/web/educationTraining/page`, { params: data })
  },
  getDetail: (id) => {
    return request.get(`/api/frLegalPlatform/web/educationTraining/${id}`)
  },
  submit: (educationTrainingId, data) => {
    return request.post(`/api/frLegalPlatform/web/educationTraining/apply/${educationTrainingId}`, data)
  }
}
